import React,{useState,useEffect} from "react";
import {Helmet} from 'react-helmet';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './whatsapp';
import axios from 'axios';
import Chat from './chat';
import Call from './call';
import Marquee from './marquee';


const Contact = () => {
  const [contactData,setcontactData]=useState([]);
  const [formData,setFormData]=useState({
   name:'',
   email:'',
   subject:'',
   message:''
  })
   
  const handleSubmit=async(e)=>{
   e.preventDefault();
  try{
   const res=await axios.post(`https://api.squareandangle.pranatigroup.in/api/admin/contactsubmit`,formData);
   alert('Saved successfully');

   setFormData({
    name: "",
    email: "",
    subject: "",
    message: "",
  
   })
   
  }catch(error){
 alert('error');
  }
  }
  
  const handlechange=(e)=>{
    setFormData({
      ...formData,
      [e.target.name]:e.target.value
    });
  }


  useEffect(()=>{
    const fetchData=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/contact`);
     setcontactData(res.data);
      }catch(error){
      console.error(error);
      }
    }
  fetchData();
  },[]);
  
  return (
    <>
    
   <div className="App">
  <Header />
  <Marquee/>
   <Helmet>
        <title>Pranati Interior - Kolkata best Interior</title>
        <meta name="description" content="Welcome to Kolkata best interior" />

        <link rel="canonical" href="https://squareandangle.pranatigroup.in/contact" />

        <meta property="og:title" content="Pranati interior" />
        <meta property="og:description" content="Kolkata best Interior" />
        <meta property="og:image" content="/images/preview.png" />
        <meta property="og:url" content="https://squareandangle.pranatigroup.in/contact" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pranati interior" />
        <meta name="twitter:description" content="Kolkata best Interior" />
        <meta name="twitter:image" content="/images/preview.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Pranati Interior",
            "url": "https://squareandangle.pranatigroup.in/contact",
            "description": "Kolkata best Interior",
            "image": "https://squareandangle.pranatigroup.in/images/preview.png",
            "areaServed": "Kolkata",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Kolkata",
              "addressRegion": "West Bengal",
              "addressCountry": "IN"
            }
          })}
        </script>
      </Helmet>



<div
  style={{
    background: "#fff",
    padding: "70px 0",
    width: "100%",
  }}
>
  <div
    className="container"
    style={{
      maxWidth: "1250px",
      margin: "0 auto",
      padding: "0 15px",
    }}
  >
    {/* INTRO */}
    <div
      style={{
        maxWidth: "850px",
        margin: "0 auto 45px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          color: "#b08d57",
          fontSize: "12px",
          fontWeight: "700",
          letterSpacing: "3px",
          textTransform: "uppercase",
          marginBottom: "12px",
        }}
      >
        Get In Touch
      </div>

      <h2
        style={{
          color: "#1f2933",
          fontSize: "clamp(28px, 4vw, 42px)",
          fontWeight: "700",
          margin: "0 0 18px",
          lineHeight: "1.2",
        }}
      >
        Let's Create Something
        <span style={{ color: "#b08d57" }}> Beautiful</span>
      </h2>

      <p
        style={{
          color: "#68717b",
          fontSize: "15px",
          lineHeight: "1.8",
          margin: 0,
        }}
      >
        Welcome to Square & Angle, the epitome of excellence in interior
        design in Kolkata. Our journey began with a singular vision:
        transforming spaces into sophisticated and inspiring experiences.
        From residential homes to commercial spaces, our team creates
        interiors that reflect your personality and lifestyle.
      </p>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        background: "#ffffff",
        borderRadius: "18px",
        overflow: "hidden",
        boxShadow: "0 18px 55px rgba(35, 31, 28, 0.10)",
        border: "1px solid #ebe5dc",
      }}
    >
      <div
        style={{
          padding: "clamp(25px, 5vw, 55px)",
        }}
      >
        <div style={{ marginBottom: "30px" }}>
          <span
            style={{
              display: "inline-block",
              color: "#b08d57",
              fontSize: "11px",
              fontWeight: "700",
              letterSpacing: "2px",
              textTransform: "uppercase",
              marginBottom: "9px",
            }}
          >
            Contact Us
          </span>

          <h3
            style={{
              margin: 0,
              color: "#20252b",
              fontSize: "28px",
              fontWeight: "700",
            }}
          >
            Start Your Project
          </h3>

          <p
            style={{
              color: "#7a8188",
              fontSize: "14px",
              lineHeight: "1.7",
              marginTop: "10px",
              marginBottom: 0,
            }}
          >
            Tell us about your project and our design team will get back
            to you shortly.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "17px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#39414a",
                  marginBottom: "7px",
                }}
              >
                FULL NAME
              </label>

              <input
                type="text"
                name="name"
                placeholder="Your name"
                value={formData.name}
                onChange={handlechange}
                style={{
                  width: "100%",
                  height: "48px",
                  padding: "0 14px",
                  border: "1px solid #ddd8d0",
                  borderRadius: "7px",
                  background: "#faf9f7",
                  color: "#333",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#39414a",
                  marginBottom: "7px",
                }}
              >
                EMAIL ADDRESS
              </label>

              <input
                type="email"
                name="email"
                placeholder="Your email"
                value={formData.email}
                onChange={handlechange}
                style={{
                  width: "100%",
                  height: "48px",
                  padding: "0 14px",
                  border: "1px solid #ddd8d0",
                  borderRadius: "7px",
                  background: "#faf9f7",
                  color: "#333",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: "17px" }}>
            <label
              style={{
                display: "block",
                fontSize: "12px",
                fontWeight: "700",
                color: "#39414a",
                marginBottom: "7px",
              }}
            >
              SUBJECT
            </label>

            <input
              type="text"
              name="subject"
              placeholder="How can we help you?"
              value={formData.subject}
              onChange={handlechange}
              style={{
                width: "100%",
                height: "48px",
                padding: "0 14px",
                border: "1px solid #ddd8d0",
                borderRadius: "7px",
                background: "#faf9f7",
                color: "#333",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ marginBottom: "22px" }}>
            <label
              style={{
                display: "block",
                fontSize: "12px",
                fontWeight: "700",
                color: "#39414a",
                marginBottom: "7px",
              }}
            >
              MESSAGE
            </label>

            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your requirements..."
              value={formData.message}
              onChange={handlechange}
              style={{
                width: "100%",
                padding: "13px 14px",
                border: "1px solid #ddd8d0",
                borderRadius: "7px",
                background: "#faf9f7",
                color: "#333",
                fontSize: "14px",
                outline: "none",
                resize: "vertical",
                minHeight: "120px",
                boxSizing: "border-box",
              }}
            ></textarea>
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              height: "50px",
              border: "none",
              borderRadius: "7px",
              background: "#b08d57",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "0.8px",
              textTransform: "uppercase",
              cursor: "pointer",
              transition: "all 0.25s ease",
              boxShadow: "0 8px 20px rgba(176, 141, 87, 0.22)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#967544";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#b08d57";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            Send Message
            <span style={{ marginLeft: "10px" }}>→</span>
          </button>
        </form>
      </div>

      <div
        style={{
          minHeight: "560px",
          position: "relative",
          background: "#e8e3db",
        }}
      >
        {contactData.length > 0 ? (
          <iframe
            title="Square & Angle Location"
            src={`https://www.google.com/maps?q=22.593756,88.389091&z=15&output=embed`}
            width="100%"
            height="100%"
            style={{
              border: 0,
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              minHeight: "560px",
              filter: "grayscale(15%) contrast(95%)",
            }}
            allowFullScreen=""
            loading="lazy"
          />
        ) : (
          <div
            style={{
              height: "100%",
              minHeight: "560px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#777",
              fontSize: "14px",
            }}
          >
            Location map unavailable
          </div>
        )}

        {contactData.length > 0 && (
          <div
            style={{
              position: "absolute",
              left: "25px",
              bottom: "25px",
              right: "25px",
              background: "rgba(255,255,255,0.96)",
              padding: "18px 20px",
              borderRadius: "10px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.14)",
              backdropFilter: "blur(8px)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "38px",
                  height: "38px",
                  flexShrink: 0,
                  borderRadius: "50%",
                  background: "#b08d57",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fa fa-map-marker"></i>
              </div>

              <div>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "#252a2f",
                    marginBottom: "4px",
                  }}
                >
                  OUR STUDIO
                </div>

                <div
                  style={{
                    fontSize: "13px",
                    color: "#68717b",
                    lineHeight: "1.5",
                  }}
                >
                  {contactData[0].text}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "1px",
        marginTop: "35px",
        background: "#ddd5ca",
        border: "1px solid #ddd5ca",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          padding: "25px 20px",
          display: "flex",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "42px",
            height: "42px",
            flexShrink: 0,
            borderRadius: "8px",
            background: "#f3eee6",
            color: "#b08d57",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "17px",
          }}
        >
          <i className="fa fa-map-marker"></i>
        </div>

        <div>
          <div
            style={{
              fontSize: "11px",
              color: "#9b7441",
              fontWeight: "800",
              letterSpacing: "1px",
              marginBottom: "6px",
            }}
          >
            ADDRESS
          </div>

          <div
            style={{
              color: "#555d65",
              fontSize: "13px",
              lineHeight: "1.6",
            }}
          >
            {contactData.length > 0 ? contactData[0].text : ""}
          </div>
        </div>
      </div>

      <div
        style={{
          background: "#ffffff",
          padding: "25px 20px",
          display: "flex",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "42px",
            height: "42px",
            flexShrink: 0,
            borderRadius: "8px",
            background: "#f3eee6",
            color: "#b08d57",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
          }}
        >
          <i className="fa fa-phone"></i>
        </div>

        <div>
          <div
            style={{
              fontSize: "11px",
              color: "#9b7441",
              fontWeight: "800",
              letterSpacing: "1px",
              marginBottom: "6px",
            }}
          >
            PHONE
          </div>

          <div
            style={{
              color: "#555d65",
              fontSize: "13px",
              lineHeight: "1.6",
            }}
          >
            {contactData.length > 0 ? contactData[0].contact : ""}
          </div>
        </div>
      </div>

      <div
        style={{
          background: "#ffffff",
          padding: "25px 20px",
          display: "flex",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "42px",
            height: "42px",
            flexShrink: 0,
            borderRadius: "8px",
            background: "#f3eee6",
            color: "#b08d57",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
          }}
        >
          <i className="fa fa-envelope"></i>
        </div>

        <div>
          <div
            style={{
              fontSize: "11px",
              color: "#9b7441",
              fontWeight: "800",
              letterSpacing: "1px",
              marginBottom: "6px",
            }}
          >
            EMAIL
          </div>

          <div
            style={{
              color: "#555d65",
              fontSize: "13px",
              lineHeight: "1.6",
              wordBreak: "break-word",
            }}
          >
            {contactData.length > 0 ? contactData[0].email : ""}
          </div>
        </div>
      </div>

      <div
        style={{
          background: "#ffffff",
          padding: "25px 20px",
          display: "flex",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "42px",
            height: "42px",
            flexShrink: 0,
            borderRadius: "8px",
            background: "#f3eee6",
            color: "#b08d57",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
          }}
        >
          <i className="fa fa-globe"></i>
        </div>

        <div>
          <div
            style={{
              fontSize: "11px",
              color: "#9b7441",
              fontWeight: "800",
              letterSpacing: "1px",
              marginBottom: "6px",
            }}
          >
            WEBSITE
          </div>

          <div
            style={{
              color: "#555d65",
              fontSize: "13px",
              lineHeight: "1.6",
            }}
          >
            Pranatigroup.in
          </div>
        </div>
      </div>
    </div>
  </div>

  <style>
    {`
      @media (max-width: 991px) {
        .contact-main-grid {
          grid-template-columns: 1fr !important;
        }
      }

      @media (max-width: 767px) {
        .contact-main-grid {
          grid-template-columns: 1fr !important;
        }

        .contact-info-grid {
          grid-template-columns: 1fr !important;
        }
      }

      @media (max-width: 575px) {
        .contact-name-email {
          grid-template-columns: 1fr !important;
        }
      }
    `}
  </style>
</div>

  <Footer />
   <WhatsAppButton />
      <Chat/>
       <Call/>
</div>

</>
  );
};


export default Contact;

